import { render } from "./LoginFailureView.vue?vue&type=template&id=bbf0c3ec&scoped=true"
import script from "./LoginFailureView.vue?vue&type=script&lang=js"
export * from "./LoginFailureView.vue?vue&type=script&lang=js"

import "./LoginFailureView.vue?vue&type=style&index=0&id=bbf0c3ec&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbf0c3ec"]])

export default __exports__